'use client'
import { useState } from 'react'
import { IconCheck, IconPhone, IconMail, IconPin } from '@/icons'
import { validateName, validatePhone } from '@/lib/validation'
import PhoneInput from '@/components/PhoneInput'
import Reveal from '@/components/Reveal'
import { postApi } from '@/lib/api'
import { deployPath } from '@/lib/site'

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '' })
  const [errs, setErrs] = useState({})
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)

  const set = (k) => (e) => {
    setForm(f => ({ ...f, [k]: e.target.value }))
    setErrs(er => ({ ...er, [k]: undefined }))
  }

  const submit = async (e) => {
    e.preventDefault()
    const next = {}
    const nameErr  = validateName(form.name)
    const phoneErr = validatePhone(form.phone)
    if (nameErr)  next.name  = nameErr
    if (phoneErr) next.phone = phoneErr
    setErrs(next)
    if (Object.keys(next).length > 0) return

    setLoading(true)
    setErrs(er => ({ ...er, submit: undefined }))
    try {
      await postApi('/api/contact', form)
      setSent(true)
      setForm({ name: '', phone: '' })
      setTimeout(() => setSent(false), 3000)
    } catch (error) {
      setErrs(er => ({ ...er, submit: error.message }))
    } finally {
      setLoading(false)
    }
  }

  return (
    <section id="contact" className="contact sec-band sec-pad">
      <div className="container contact-grid">
        <Reveal><div>
          <h2>Готовы обсудить детали?</h2>
          <p className="sub">Оставьте заявку — мы свяжемся с вами в ближайшее время</p>
          <form className="form-row" onSubmit={submit} noValidate>
            <div className={`field ${errs.name ? 'err' : ''}`}>
              <label className="sr-only" htmlFor="contact-name">Ваше имя</label>
              <input id="contact-name" name="name" type="text" placeholder="Ваше имя" value={form.name} onChange={set('name')} />
              {errs.name && <div className="em">{errs.name}</div>}
            </div>
            <div className={`field ${errs.phone ? 'err' : ''}`}>
              <label className="sr-only" htmlFor="contact-phone">Телефон</label>
              <PhoneInput id="contact-phone" name="phone" aria-label="Телефон" value={form.phone} onChange={set('phone')} />
              {errs.phone && <div className="em">{errs.phone}</div>}
            </div>
            <button type="submit" className="btn btn-primary" style={{whiteSpace:'nowrap'}} disabled={loading}>
              {loading ? 'Отправка...' : 'Отправить заявку'}
            </button>
            {errs.submit && <div className="em">{errs.submit}</div>}
            <p className="consent-text">
              Нажимая кнопку «Отправить заявку», я даю согласие на обработку моих персональных данных в соответствии с&nbsp;
              <a href={deployPath('/policy')} target="_blank" rel="noopener noreferrer" className="consent-link">Политикой конфиденциальности</a>
              &nbsp;и Федеральным законом №&nbsp;152-ФЗ «О персональных данных».
            </p>
          </form>
        </div></Reveal>
        <Reveal delay={150}><div className="contact-list">
          <div className="contact-item">
            <span className="ic"><IconPhone width="18" height="18" /></span>
            <div>
              <div className="v">+7 (917) 085-51-95</div>
              <div className="l">Позвонить нам · Пн–Пт 09:00–18:00</div>
            </div>
          </div>
          <div className="contact-item">
            <span className="ic"><IconMail width="18" height="18" /></span>
            <div>
              <div className="v">ooo-sk-aqua@yandex.ru</div>
              <div className="l">Заявки, оптовые поставки, партнёрство</div>
            </div>
          </div>
          <div className="contact-item">
            <span className="ic"><IconPin width="18" height="18" /></span>
            <div>
              <div className="v">368808, Республика Дагестан,</div>
              <div className="l">Кизлярский район, с. Краснооктябрьское, ул. Степная, стр. 47</div>
            </div>
          </div>
          <div className="contact-item">
            <span className="ic"><IconPin width="18" height="18" /></span>
            <div>
              <div className="v">416195, Астраханская обл, Володарский р-н,</div>
              <div className="l">с. Новинка, ул. Степная, дом № 6</div>
            </div>
          </div>
        </div></Reveal>
      </div>
      {sent && (
        <div className="toast">
          <IconCheck width="18" height="18" /> Заявка отправлена — мы свяжемся с вами в ближайшее время
        </div>
      )}
    </section>
  )
}
